import { BRAND_PALETTE } from './brand-palette';
import type { OrganizationTheme, OrganizationThemeColors } from './types';

/** DentXE product defaults when org branding is unset or not yet loaded. */
export const DEFAULT_ORG_THEME_COLORS: OrganizationThemeColors = {
  primary: BRAND_PALETTE.teal,
  accent: BRAND_PALETTE.orange,
};

export const DEFAULT_ORGANIZATION_THEME: OrganizationTheme = {
  organizationId: null,
  clinicName: 'DentXE',
  logoUrl: null,
  colors: DEFAULT_ORG_THEME_COLORS,
};
